(function () {
	'use strict';

	function init() {
		const triggers = document.querySelectorAll('.js-site-offcanvas-trigger');
		const offcanvas = document.querySelector('.js-site-offcanvas');
		const close = offcanvas.querySelector('.js-site-offcanvas-close');
		const activeClass = 'is-active';
		const overflowClass = 'u-overflow-hidden';

		function openOffcanvas() {
			offcanvas.classList.add(activeClass);
			document.body.classList.add(overflowClass);
		}

		function closeOffcanvas() {
			offcanvas.classList.remove(activeClass);
			document.body.classList.remove(overflowClass);
		}

		triggers.forEach((trigger) => {
			trigger.addEventListener('click', (e) => {
				e.stopPropagation();
				openOffcanvas();
			});
		});

		close.addEventListener('click', (e) => {
			e.stopPropagation();
			closeOffcanvas();
		});

		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && offcanvas.classList.contains(activeClass)) {
				closeOffcanvas();
			}
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
